import React from 'react';
import './Header.css';

interface HeaderProps {
  activeView: 'basic' | 'advanced';
  onViewChange: (view: 'basic' | 'advanced') => void;
}

const Header: React.FC<HeaderProps> = ({ activeView, onViewChange }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-container">
          <img src="/logo.svg" alt="Kaggle Search" className="logo" />
          <h1>Kaggle コンペティション・ソリューション検索</h1>
        </div>
        <p className="header-subtitle">過去のKaggleコンペティションとソリューションを検索できます</p>
        
        <div className="view-selector">
          <button 
            className={`view-button ${activeView === 'basic' ? 'active' : ''}`}
            onClick={() => onViewChange('basic')}
          >
            基本検索
          </button>
          <button 
            className={`view-button ${activeView === 'advanced' ? 'active' : ''}`}
            onClick={() => onViewChange('advanced')}
          >
            高度な検索
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
